










































import { Component, Prop, Vue } from 'vue-property-decorator';

import ModalVue from './Modal.vue';

import Image from '../../engine/Image';

/*
function rotateVector(vec, ang)
{
    ang = -ang * (Math.PI/180);
    var cos = Math.cos(ang);
    var sin = Math.sin(ang);
    return new Array(Math.round(10000*(vec[0] * cos - vec[1] * sin))/10000, Math.round(10000*(vec[0] * sin + vec[1] * cos))/10000);
};
*/

@Component({
    components: {
        ModalVue
    },
})
export default class ImageVue extends Vue {

    @Prop() private image!: string|string[];

    private vvconfig = {
        "inline": true,
        "button": false,
        "navbar": false,
        "title": false,
        "toolbar": false,
        "tooltip": false,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": false,
        "keyboard": false,
        "url": "data-source"
    };


    get images(){
        return Array.isArray(this.image) ? this.image : [this.image];
    }

    zoomInc(){
        this.viewer.zoom(0.1);
    }
    zoomDec(){
        this.viewer.zoom(-0.1);
    }
    rotateL(){
        this.viewer.rotate(-45);
        //this.viewer.moveTo(0,0);
    }
    rotateR(){
        //console.log(this.viewer.imageData.left, this.viewer.imageData.top);
        this.viewer.rotate(45);
    }

    get viewer(){
        const elem = this.$el.querySelector('.v-viewer');
        // @ts-ignore
        return elem.$viewer;
    }


    close(){
        this.$emit('close');
    }


}

